var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "booking-element booking-error" },
      _vm._l(_vm.errors, function(err) {
        return _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "booking-error--label column small-12 medium-3 large-3"
            },
            [_c("b", [_vm._v(_vm._s(err.name))])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "booking-error--message column small-12 medium-9 large-9"
            },
            [_vm._v(_vm._s(err.message))]
          )
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "booking-element text-center" }, [
      _c(
        "a",
        {
          staticClass: "cta cta--inverse cta--inline",
          on: { click: _vm.stepBack }
        },
        [_vm._v("Zurück")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }